<template>
  <div>
    
    <div class="login-form">
      <div style="text-align:center;font-size:20px;margin-bottom:20px">员工业绩数字管理平台</div>
      <a-form :form="form" name="loginform" layout="horizontal" hideRequiredMark @submit="loginForm">
        <a-form-item :labelCol="{span:4,offset:2}" :wrapperCol="{span:14}" label="账号">
          <a-input
            v-decorator="[
              'account',
              { rules: [{ required: true, message: '账号不能为空!' }] }
            ]"
            placeholder="请输入账号"
          />
        </a-form-item>
        <a-form-item :labelCol="{span:4,offset:2}" :wrapperCol="{span:14}" label="密码">
          <a-input
            v-decorator="[
              'password',
              { rules: [{ required: true, message: '密码不能为空!' }] }
            ]"
            type="password"
            placeholder="请输入密码"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 18, offset: 4 }">
          <a-button type="primary" htmlType="submit" class="login-button">登录</a-button>
          <a-button class="login-button">重置</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { user } from '@/api/user'
export default {
  name: "login",
  props: {},
  data() {
    return {};
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    
  },
  methods: {
    loginForm(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          const userinfo = user(values)
          userinfo.then((res) => {
            // console.log(res)
            if (res.data.errno === 0) {
              localStorage.setItem('token',res.data.results.token)
              localStorage.setItem('user',JSON.stringify(res.data.results.user))
              this.$router.push('/home');
            }else {
              this.$message.error(res.data.msg);
            }
          })
        }
      });
    }
  },
};
</script>

<style scoped lang="less">
.login {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #000000;
}
.login-form {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 522px;
  height: 399px;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background: rgba(229, 238, 238, 0.7);
  z-index: 1999;
  padding-top: 110px;
  border-radius: 7px;
  .login-button {
    margin-top: 20px;
    width: 125px;
    height: 45px;
    font-size: 16px;
  }
  .login-button:first-child {
    margin-right: 60px;
  }
}
.ant-form label {
    font-size: 0.09rem;
}
.ant-form-item-children {
  input {
    height: 45px;
    font-size: 16px;
  }
}
</style>
